import { useFrontendConfigContext as V } from "../../../config-lib/contexts/FrontendConfigContext.js";
import { CurrencyTokenType as S } from "../../../currency-lib/constants/currency.js";
import "../../../currency-lib/contexts/CurrencyContext.js";
import "../../../currency-lib/deserialize/yup/currency.js";
import X from "../../../currency-lib/hooks/graphql/useGetCurrencyInfo.js";
import "@apollo/client";
import "../../../currency-lib/graphql/query/getOffChainTokenBalances.js";
import * as d from "ramda";
import { useMemo as Z, useCallback as a } from "react";
import "../../../currency-lib/hooks/graphql/useGetTokenPriceToUSD.js";
import { ChainNetworkType as x } from "../../constants/chain.js";
import { ERROR_CODE as C } from "../../constants/error.js";
import { WalletType as l, WAGMI_RECENT_CONNECTOR_ID as nn, WalletExtensionRdns as R } from "../../constants/web3.js";
import { useConfigContext as tn } from "../../contexts/config/ConfigContext.js";
import { CustomError as w } from "../../errors/customError.js";
import on from "../generic/useChainSwitcher.js";
import { toWei as en, fromWei as cn } from "../../util/erc20/index.js";
import { getConnectors as O, disconnect as U, getAccount as _, getBalance as rn, readContract as sn, getConnections as B, switchAccount as an, reconnect as D, connect as E, signTypedData as ln, signMessage as fn } from "@wagmi/core";
import { erc20Abi as un, parseUnits as dn, formatUnits as wn } from "viem";
const gn = {
  toWei: (g, h = 18) => dn(g, h),
  fromWei: (g, h = 18) => wn(g, h)
}, N = (g) => {
  switch (g) {
    case l.Metamask:
      return R.Metamask;
    case l.Okx:
      return R.Okx;
    case l.Ronin:
      return R.Ronin;
    case l.RoninMobile:
    case l.WalletConnect:
      return R.WalletConnect;
    default:
      throw new w(`Invalid wallet type ${g}`);
  }
}, Gn = () => {
  var M;
  const {
    config: g
  } = tn(), {
    waitConfig: h
  } = V(), {
    fetch: v
  } = X(), u = (M = g.web3) == null ? void 0 : M.wagmiConfig, I = Z(() => d.isNotNil(u) ? O(u) : [], [u]), {
    getChainConfigs: k,
    getChainIdByType: b
  } = on(), r = a(() => {
    if (d.isNil(u))
      throw new w("Wagmi config cannot be null, if you call useWeb3 function", C.CONTRACT.WAGMI_CONFIG_IS_NULL);
    return u;
  }, [u]), T = a(async () => {
    const n = r();
    await U(n);
  }, [r]), p = a(async (n) => {
    const t = r();
    let e;
    if (n) {
      const c = O(t).find((f) => f.id === N(n));
      if (!c)
        return !0;
      e = await (c == null ? void 0 : c.getChainId());
    } else {
      const i = _(t);
      if (!i.isConnected || !i.chainId)
        return !0;
      e = i.chainId;
    }
    const o = k(), s = d.pluck("chainId", o);
    return d.includes(e, s);
  }, [k, r]), $ = a(async (n) => {
    if (!await p(n))
      throw new w("Wrong network", C.LOGIN.WRONG_NETWORK);
  }, [p]), q = a(async (n) => {
    const t = r(), e = await h(), o = await v((e == null ? void 0 : e.supportToken.allTokens.onChain) || []), s = d.values(o || {});
    let i = [0, 0];
    const c = d.map((f) => ({
      functionName: "balanceOf",
      address: (f == null ? void 0 : f.address) || "",
      abi: un,
      args: [n]
    }), s);
    try {
      const f = await rn(t, {
        address: n
      }), J = await Promise.allSettled(d.map((m) => sn(t, m), c));
      i = d.map((m) => m.status === "fulfilled" ? m.value : 0, J);
      let L = {};
      return s.forEach((m, Q) => {
        L = d.assoc((m == null ? void 0 : m.type) || S.Unspecified, String(i[Q] || "0"), L);
      }), {
        ...L,
        [S.Ron]: String(f.value || "0")
      };
    } catch (f) {
      return console.error(f), {};
    }
  }, [v, r, h]), W = a((n = l.None) => {
    if (typeof window > "u")
      return !1;
    switch (n) {
      case l.WalletConnect:
      case l.RoninMobile:
        return !0;
      case l.Ronin:
        return window.ronin !== void 0;
      case l.Okx:
        return window.okxwallet !== void 0;
      case l.Metamask:
        return window.ethereum !== void 0;
      default:
        return !1;
    }
  }, []), F = a(async ({
    walletType: n,
    networkType: t
  }) => {
    const e = r(), s = B(e).find((c) => c.connector.id === N(n));
    if (s)
      return await an(e, {
        connector: s.connector
      }), await D(e, {
        connectors: [s.connector]
      }), {
        address: s.accounts[0],
        chainId: s.chainId
      };
    const i = I.find((c) => c.id === N(n));
    if (!i)
      throw new w(`Connector not found for wallet type ${n}`, C.LOGIN.NOT_YET_INSTALL_WALLET);
    try {
      const {
        accounts: c,
        chainId: f
      } = await E(e, {
        connector: i,
        chainId: b(t)
      });
      return {
        address: c[0],
        chainId: f
      };
    } catch (c) {
      const f = c;
      throw c instanceof w ? c : new w(`fail to connect wallet, reason: ${f.message}`, C.LOGIN.CANNOT_CONNECT_WALLET);
    }
  }, [r, I, b]), y = a(async () => {
    const n = r();
    try {
      const t = (localStorage.getItem(nn) || "").replace(/['"]+/g, ""), o = O(n).find((c) => c.id === t);
      if (!o) return !1;
      const {
        accounts: s
      } = await E(n, {
        connector: o,
        chainId: await (o == null ? void 0 : o.getChainId())
      });
      return s.length !== 0;
    } catch {
      return !1;
    }
  }, [r]), G = a((n) => I.find((e) => e.id === N(n)), [I]), A = a((n, t = []) => {
    if (t.length === 0 && (t = n === x.Ronin ? [l.Ronin, l.Okx] : [l.Metamask]), !t.some((o) => W(o)))
      throw new w("Wallet not installed", C.LOGIN.NOT_YET_INSTALL_WALLET);
  }, [W]), Y = a(async (n) => {
    const t = r();
    return A(x.Ronin), await y(), ln(t, n);
  }, [r, y, A]), P = a(async (n, t) => {
    const e = r();
    try {
      let o;
      if (t) {
        if (!W(t))
          throw new w(`Connector not found for wallet type ${t}`, C.LOGIN.NOT_YET_INSTALL_WALLET);
        o = G(t);
      }
      return !_(e).isConnected && o && await E(e, {
        connector: o
      }), await fn(e, {
        connector: o,
        message: n
      });
    } catch (o) {
      const s = o;
      throw T(), o instanceof w ? o : new w(`fail to sign signature, reason: ${s.message}`, C.LOGIN.CANNOT_SIGN_SIGNATURE);
    }
  }, [r, W, G, T]), K = a(async (n, t) => {
    const e = r(), o = await p(n), i = O(e).find((c) => c.id === N(n));
    if (!i)
      return !1;
    try {
      return !o && i.switchChain && await i.switchChain({
        chainId: t
      }), !0;
    } catch (c) {
      return console.error(c), !1;
    }
  }, [r, p]), j = a(async () => d.isNotNil(u) ? (await D(u), _(u)) : {
    address: void 0,
    addresses: void 0,
    chain: void 0,
    chainId: void 0,
    connector: void 0,
    isConnected: !1,
    isReconnecting: !1,
    isConnecting: !1,
    isDisconnected: !0,
    status: "disconnected"
  }, [u]), z = a(() => {
    const n = r();
    return B(n);
  }, [r]), H = a((n) => {
    const t = r();
    return U(t, {
      connector: n
    });
  }, [r]);
  return {
    cleanSession: T,
    correctNetwork: p,
    getBalances: q,
    signRequest: P,
    switchNetworkAndRequestAddress: K,
    toWei: en,
    fromWei: cn,
    walletInstalled: W,
    web3Utils: gn,
    connectWallet: F,
    manualReconnect: y,
    getWalletRdnsFromWalletType: N,
    connectors: I,
    getWalletAccount: j,
    validateNetwork: $,
    validateWalletInstalled: A,
    sign712TypedData: Y,
    getWalletConnections: z,
    disconnectWallet: H,
    wagmiConfig: u
  };
};
export {
  Gn as default
};
//# sourceMappingURL=useWeb3.js.map
